export const openPdfWithBase64 = (base64, title) => {
  let pdfWindow = window.open('');
  pdfWindow.document.write(
    '<html<head><title>' +
      title +
      '</title><style>body{margin: 0px; overflow: hidden}iframe{border-width: 0px;}</style></head>'
  );
  pdfWindow.document.write(
    "<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +
      encodeURI(base64) +
      "#navpanes=0&scrollbar=0'></embed></body></html>"
  );
};
